import { Element } from 'react-scroll';

function ScrollSection({ name, children }) {
  return (
    <Element name={name} style={{ width: '100%' }}>
      {children}
    </Element>
  );
}

export default ScrollSection;
